import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { isMobile, isIPad13 } from 'react-device-detect';

import MobileModal from './ui/components/MobileModal';

import NavigationBar from './ui/components/NavigationBar';
import FormulasFragment from './ui/pages/formuls/FormulasFragment';
import TermsFragment from "./ui/pages/terms/TermsFragment";

import SettingsPage from './ui/pages/setting/SettingPage';
import SettingsLanguage from './ui/pages/setting/SettingsLanguage';

import ComingSoon from './ui/pages/ComingSoon';

// Выносим контент в отдельный компонент, чтобы иметь доступ к useLocation
const AppContent = () => {
    const { t } = useTranslation();

    const location = useLocation();
    const background = location.state && location.state.background;

    if (isMobile || isIPad13) {
        return (
            <Router>
                <Switch>
                    {/* Разрешаем просмотр политики конфиденциальности даже на мобилках */}
                    {/* <Route path="/privacy-policy" component={() => <div>Privacy Policy Content</div>} /> */}

                    <Route component={MobileModal} />
                </Switch>
            </Router>
        );
    }

    return (
        <div className="page-main">
            <NavigationBar />

            <div className="page-main__wrapper">
                {/* Магия здесь: если есть background, Switch будет думать,
                  что мы всё еще на странице формул/терминов, и не скроет их!
                */}
                <Switch location={background || location}>
                    <Route exact path="/"><Redirect to="/formuls" /></Route>

                    {/*--FORMULS---*/}
                    <Route path="/formuls/:categoryId/:formulaId" component={ FormulasFragment } />
                    <Route path="/formuls" component={ FormulasFragment } />

                    {/*--TERMS---*/}
                    <Route path="/terms/:colorId/:termId" component={ TermsFragment} />
                    <Route path="/terms" component={ TermsFragment } />

                    {/*--В РАЗРАБОТКЕ---*/}
                    <Route path="/calcs"><ComingSoon sectionName={t('translate.calc_name')} color="#667EEA" /></Route>
                    <Route path="/tables"><ComingSoon sectionName={t('translate.tables_name')} color="#FE2D2D" /></Route>

                    {/* <Route path="/calcs"> <div style={{ padding: 40 }}><h1>Калькуляторы</h1></div></Route> */}
                    {/* <Route path="/tables"> <div style={{ padding: 40 }}><h1>Таблицы</h1></div></Route> */}
                    {/* <Route path="/other"> <div style={{ padding: 40 }}><h1>Другое</h1></div></Route> */}

                </Switch>

                {/*---НАСТРОЙКИ-ПОВЕРХ-ВСЕГО-КОНТЕНТА---*/}
                <Route path="/settings/language" component={ SettingsLanguage } />
                <Route exact path="/settings" component={ SettingsPage } />
            </div>
        </div>
    );
};

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;